import {
  consolidationConfig as consolidationConfig_,
  directStakingConfig as directStakingConfig_,
  executionWithdrawalConfig as executionWithdrawalConfig_,
  rewardPoolConfig as rewardPoolConfig_,
} from '#/generated';
import { Address, getAddress } from 'viem';

function wrapConfig<T>(config: { abi: T; address: Record<number, Address> }) {
  return {
    abi: config.abi,
    address: (chainId: number) => getAddress(config.address[chainId]),
  };
}

export const directStakingConfig = wrapConfig(directStakingConfig_);

export const rewardPoolConfig = wrapConfig(rewardPoolConfig_);

export const consolidationConfig = wrapConfig(consolidationConfig_);

export const executionWithdrawalConfig = wrapConfig(executionWithdrawalConfig_);
